/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ObjectStore } from "./ObjectStore";
import {
  ObjectStoreFromJSON,
  ObjectStoreFromJSONTyped,
  ObjectStoreToJSON,
} from "./ObjectStore";

export interface ObjectStoreListResponse {
  offset: number;
  limit: number;
  order: string;
  sort: string;
  count: number;
  data: Array<ObjectStore>;
}

export function ObjectStoreListResponseFromJSON(
  json: any,
): ObjectStoreListResponse {
  return ObjectStoreListResponseFromJSONTyped(json);
}

export function ObjectStoreListResponseFromJSONTyped(
  json: any,
): ObjectStoreListResponse {
  if (json == null) {
    return json;
  }

  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(ObjectStoreFromJSON),
  };
}

export function ObjectStoreListResponseToJSON(
  value: ObjectStoreListResponse | null | undefined,
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(ObjectStoreToJSON),
  };
}
